import type { TimeEntry } from '@scrambl/shared'
import {
  calendarDateFromPicker,
  calendarDateFromStorage,
  calendarDateInTimeZone,
  calendarDateToPicker,
  timeEntryHours,
} from '@scrambl/shared'
import { clockInTimeZone } from '@scrambl/shared/zoned-time'

export function initialEntryClocks({
  entry,
  defaultDate,
  defaultStartTime,
  defaultEndTime,
  timezone,
  formatHours,
}: {
  entry?: TimeEntry | null
  defaultDate?: Date
  defaultStartTime?: Date
  defaultEndTime?: Date
  timezone: string
  formatHours: (hours: number) => string
}) {
  const instant = (value: Date | string | null | undefined) => {
    if (!value) return null
    const result = new Date(value)
    return Number.isFinite(result.getTime()) ? result : null
  }
  const start = instant(entry ? entry.startTime : defaultStartTime)
  const end = instant(entry ? entry.endTime : defaultEndTime)
  const recordedDay =
    (entry && calendarDateFromStorage(entry.entryDate)) ||
    (!entry && defaultDate && calendarDateFromPicker(defaultDate)) ||
    calendarDateInTimeZone(start ?? new Date(), timezone)
  const startDay = start ? calendarDateInTimeZone(start, timezone) : recordedDay
  const endDay = end ? calendarDateInTimeZone(end, timezone) : startDay
  const active = entry?.entryType === 'TIMER' && !entry.endTime
  const hours = active
    ? ''
    : entry
      ? formatHours(timeEntryHours(entry))
      : start && end && end > start
        ? formatHours((end.getTime() - start.getTime()) / 3600_000)
        : ''
  return {
    date: calendarDateToPicker(recordedDay)!,
    startDate: calendarDateToPicker(startDay)!,
    endDate: calendarDateToPicker(endDay)!,
    startTime: start ? clockInTimeZone(start, timezone) : '',
    endTime: end ? clockInTimeZone(end, timezone) : '',
    startOccurrence: undefined,
    endOccurrence: undefined,
    hours,
  }
}
